var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25C12.2812 0.25 15.75 3.71875 15.75 8C15.75 12.2812 12.2812 15.75 8 15.75C3.71875 15.75 0.25 12.2812 0.25 8C0.25 3.71875 3.71875 0.25 8 0.25ZM11.7812 10.0625L9.75 8L11.7812 5.96875C11.9375 5.84375 11.9375 5.59375 11.7812 5.4375L10.5625 4.21875C10.4062 4.0625 10.1562 4.0625 10.0312 4.21875L8 6.25L5.96875 4.21875C5.8125 4.0625 5.5625 4.0625 5.4375 4.21875L4.1875 5.4375C4.03125 5.59375 4.03125 5.84375 4.1875 5.96875L6.25 8L4.1875 10.0312C4.03125 10.1875 4.03125 10.4375 4.1875 10.5625L5.40625 11.8125C5.5625 11.9688 5.8125 11.9688 5.9375 11.8125L8 9.75L10.0312 11.8125C10.1562 11.9688 10.4062 11.9688 10.5625 11.8125L11.7812 10.5938C11.9375 10.4375 11.9375 10.1875 11.7812 10.0625Z",
    fill: "#037CB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3f5a1ce2b338c7b6fa67e5c8f7b42adb.svg";
export { ForwardRef as ReactComponent };